export default __webpack_public_path__ + "4bdd6858b24398087de7e3392965d469.png";